import { render } from "./Speed075.vue?vue&type=template&id=477064c4"
import script from "./Speed075.vue?vue&type=script&lang=js"
export * from "./Speed075.vue?vue&type=script&lang=js"
script.render = render

export default script